/**
 * Ligação das telas de grupo com a viagem ativa. Mesmo padrão do financeiro:
 * as telas recebem por prop e continuam testáveis sem contexto.
 */
import type { ReactElement } from 'react';

import { useTrip } from '../../trip/TripContext';
import { ErrorState, Skeleton } from '../../ui/primitives';
import { ConvitesScreen } from './ConvitesScreen';
import { CriarFamiliaScreen } from './CriarFamiliaScreen';
import { GrupoScreen } from './GrupoScreen';
import { NegadoScreen } from './NegadoScreen';
import { PermissoesScreen } from './PermissoesScreen';
import { TransferirScreen } from './TransferirScreen';

function ComViagem({
  render,
}: {
  render: (t: ReturnType<typeof useTrip>) => ReactElement;
}) {
  const viagem = useTrip();

  if (viagem.carregando) {
    return (
      <section className="grupo">
        <Skeleton height={48} count={3} />
      </section>
    );
  }

  if (viagem.erro) {
    return (
      <section className="grupo">
        <ErrorState
          title="Não foi possível carregar a viagem"
          description="Verifique a conexão. O que já está no aparelho continua salvo."
          onRetry={() => window.location.reload()}
        />
      </section>
    );
  }

  return render(viagem);
}

export const GrupoRoute = () => (
  <ComViagem
    render={(v) => (
      <GrupoScreen
        tripId={v.tripId}
        membros={v.members}
        meuMemberId={v.meuMemberId}
        permissoes={v.permissions}
      />
    )}
  />
);

export const PermissoesRoute = () => (
  <ComViagem
    render={(v) => (
      <PermissoesScreen
        tripId={v.tripId}
        ator={{
          memberId: v.meuMemberId,
          role: v.members.find((m) => m.memberId === v.meuMemberId)?.role ?? 'participant',
          permissions: v.permissions,
        }}
      />
    )}
  />
);

export const TransferirRoute = () => (
  <ComViagem
    render={(v) => (
      <TransferirScreen
        tripId={v.tripId}
        membros={v.members}
        meuMemberId={v.meuMemberId}
        souDono={
          v.members.find((m) => m.memberId === v.meuMemberId)?.role === 'owner'
        }
      />
    )}
  />
);

export const CriarFamiliaRoute = () => (
  <ComViagem
    render={(v) => (
      <CriarFamiliaScreen tripId={v.tripId} membros={v.members} meuMemberId={v.meuMemberId} />
    )}
  />
);

export const NegadoRoute = () => (
  <ComViagem
    render={(v) => (
      <NegadoScreen membros={v.members} meuMemberId={v.meuMemberId} permissoes={v.permissions} />
    )}
  />
);

export const ConvitesRoute = () => (
  <ComViagem
    render={(v) => (
      <ConvitesScreen tripId={v.tripId} tripName={v.trip.name} permissoes={v.permissions} />
    )}
  />
);
